module.exports = __webpack_public_path__ + "static/media/SaifeeEvents95.8bbe73e9.jpg";